import React, {useState, useEffect} from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import Loading from '#components/a/Loading'
import PraxisaufgabenKachel from '#components/o/Uebersicht/PraxisaufgabenKachel'
import Headline from '#components/a/Headline'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Api from '#services/api'

function UebersichtPraxisaufgaben({userInfo}) {
  const {firstname} = userInfo
  const [praxisaufgabenModel, setPraxisaufgabenModel] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (praxisaufgabenModel === undefined) {
      setPraxisaufgabenModel(null)
      setIsLoading(true)
      Api.readPraxisaufgabenForAusbilderDashboard()
        .then(result => {
          setPraxisaufgabenModel(result)
          setIsLoading(false)
        })
        .catch(error => {
          actions.error.writeError({error})
          setIsLoading(false)
        })
    }
  }, [praxisaufgabenModel])

  return (
    <div className="uebersicht">
      <div className="header-wrapper">
        <Headline importance={1} modifier="section" text={i18n.t('meineausbildung_page_title', [firstname])} />
      </div>
      <div className="uebersicht__page">
        {isLoading ? <Loading /> : <PraxisaufgabenKachel praxisaufgabenModel={praxisaufgabenModel} showAllItems />}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  userId: state.authentication.id,
})

UebersichtPraxisaufgaben.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
  }).isRequired,
}

export default connect(mapStateToProps)(UserInfoHOC(UebersichtPraxisaufgaben))
